import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import * as actions from "../../../store/actions/";
import { VERIFY_EMAIL } from "../../../store/actions/actionTypes";

import Row from "../../../components/uiElements/grid/Row";
import Button from "../../../components/formElements/button/Button";
import TextInput from "../../../components/formElements/input/TextInput";
import { getOnboardingPath } from "../../../constants";
import SpinnerBorder from "../../../components/uiElements/loadingSpinner/SpinnerBorder";

const VerifyEmail = ({
  signUpData,
  setSignUpData,
  form,
  validateData,
  verifyEmail,
  apiUtil,
  emailVerification,
  signUp,
  history,
}) => {
  useEffect(() => {
    if (form && form.verificationValid) {
      verifyEmail(() => {
        signUp(() => history.push(getOnboardingPath("/")));
        form.verificationValid = false;
      });
    }
    // eslint-disable-next-line
  }, [form]);

  return (
    <div className="container" style={{ marginTop: "10%", maxWidth: 400 }}>
      <h2 className="auth-header mb-5">
        Verify
        <br /> Email
      </h2>
      <p className="mb-5">
        We have sent a verification code on your email. Please enter the code
        below.
      </p>
      <Row>
        <div
          className="col-md-12 text-left mt-4"
          onKeyDown={event => {
            if (event.keyCode === 13) {
              validateData(signUpData);
            }
          }}
        >
          <TextInput
            error={form.verificationCode}
            type="text"
            label="Verification Code"
            value={signUpData.verificationCode}
            onChange={val => setSignUpData({ verificationCode: val })}
          />
        </div>
      </Row>
      <div>
        <Button
          label={apiUtil.isLoading ? <SpinnerBorder /> : "Verify Email"}
          className="mb-4"
          onClick={() => validateData(signUpData)}
        />
      </div>
      <p className="text-center">
        <Link
          className="link"
          onClick={() => {
            setSignUpData({ verificationCode: undefined });
            emailVerification();
          }}
        >
          Resend Verification Code
        </Link>
      </p>
    </div>
  );
};

const mapStoreToProps = ({ registration, validation, api }) => ({
  signUpData: registration,
  form: validation.data,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  setSignUpData: updatedData => dispatch(actions.setSignUpData(updatedData)),
  validateData: verificationData =>
    dispatch(actions.validateData(VERIFY_EMAIL, verificationData)),
  verifyEmail: cb => dispatch(actions.verifyEmail(cb)),
  emailVerification: () => dispatch(actions.emailVerification()),
  signUp: cb => dispatch(actions.signUp(cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(VerifyEmail)
);
